"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/ResetPassword/Form.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Form = require('web/components/Form');
var _AuthFrame = require('web/components/AuthFrame');
var _PasswordInput = require('web/components/PasswordInput'); var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
var _app = require('shared/constants/app');
var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);

 const validationErrorMsgs = {
  weakPassword: "Password isn't strong enough",
  passwordMismatch: "Passwords don't match",
}; exports.validationErrorMsgs = validationErrorMsgs



 const errorMsgs = {
  "Invalid Token": "This link is invalid. Please request a new password reset.",
  "Token Previously Used": "This link has already been used. Please request a new password reset.",
  "Token Expired": "This link has expired. Please request a new password reset.",
  "weak password": "Please choose a stronger password: Include a mix of upper- and lowercase letters, numbers, punctuation, and avoid names (including 'bloom') and dates.",
  "generic": "Couldn't set a new password. Please try again later or contact support@bloomtext.com.",
}; exports.errorMsgs = errorMsgs






const passwordInputId = 'password'
const passwordConfirmationInputId = 'passwordConfirmation'

const getValidationError = (password, passwordConfirmation, isPasswordStrong) => {
  if (!isPasswordStrong) return exports.validationErrorMsgs.weakPassword
  if (password !== passwordConfirmation) return exports.validationErrorMsgs.passwordMismatch
  return null
}

// Was a PureComponent: memo keeps the shallow props bail-out, and each state
// field is its own useState, so an update that changes nothing skips the
// children's render as the PureComponent's shallow state check did (React
// may still run this body once before bailing out, which has no effect). The handlers keep
// stable identities (PasswordInput gets them) and read the committed state and
// props through `latest`, as the class read `this.state`/`this.props`.
const ResetPasswordForm = (props) => {
  const { email } = props
  const [password, setPassword] = _react.useState.call(void 0, "")
  const [passwordConfirmation, setPasswordConfirmation] = _react.useState.call(void 0, "")
  const [errorMessage, setErrorMessage] = _react.useState(null)
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const [isAnyFieldTouched, setIsAnyFieldTouched] = _react.useState.call(void 0, false)
  const [isPasswordStrong, setIsPasswordStrong] = _react.useState.call(void 0, false)
  // A field's problem shows once they leave it after typing, never while
  // they type, and clears as soon as it is fixed.
  const display = _useFieldErrorDisplay2.default.call(void 0, {
    [passwordInputId]: password && !isPasswordStrong ? exports.validationErrorMsgs.weakPassword : undefined,
    [passwordConfirmationInputId]: passwordConfirmation && password !== passwordConfirmation
      ? exports.validationErrorMsgs.passwordMismatch
      : undefined,
  })
  const { onType, onLeave } = display
  const onPasswordBlur = _react.useCallback.call(void 0, () => onLeave(passwordInputId, password), [onLeave, password])
  const onConfirmationBlur = _react.useCallback.call(void 0, 
    () => onLeave(passwordConfirmationInputId, passwordConfirmation),
    [onLeave, passwordConfirmation],
  )

  const latest = _react.useRef.call(void 0, { props, password, passwordConfirmation, isPasswordStrong })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { props, password, passwordConfirmation, isPasswordStrong }
  })

  const handleChange = _react.useCallback.call(void 0, (inputId, value) => {
    // The class set `state[inputId]`; only these two ids exist.
    onType(inputId)
    if (inputId === passwordInputId) setPassword(value)
    if (inputId === passwordConfirmationInputId) setPasswordConfirmation(value)
    setIsAnyFieldTouched(true)
  }, [onType])

  const setPasswordStrength = _react.useCallback.call(void 0, (isStrong) => setIsPasswordStrong(isStrong), [])

  const handleSubmit = _react.useCallback.call(void 0, (e) => {
    e.preventDefault()
    const { props: { onSubmit }, password: currentPassword } = latest.current

    const submitError = getValidationError(
      currentPassword,
      latest.current.passwordConfirmation,
      latest.current.isPasswordStrong,
    )
    if (submitError) return setErrorMessage(submitError)

    setIsLoading(true)
    setIsAnyFieldTouched(false)
    setErrorMessage(null)

    onSubmit(currentPassword)
      .catch((err) => {
        setErrorMessage(exports.errorMsgs[err.Response] || exports.errorMsgs.generic)
        setIsLoading(false)
      })
  }, [])

  const validationErrorMessage = getValidationError(password, passwordConfirmation, isPasswordStrong)
  const shownValidationError = display.shown(passwordInputId) || display.shown(passwordConfirmationInputId)
  const isSubmitBtnEnabled = !isLoading &&
    (isAnyFieldTouched ? !validationErrorMessage : errorMessage)

  return (
    _react2.default.createElement('form', { onSubmit: handleSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
      , _react2.default.createElement('input', {
        readOnly: true,
        type: "text",
        name: "email",
        autoComplete: "username",
        className: "blmh-hide",
        value: email, __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
      )
      , _react2.default.createElement('label', { className: "blm-input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
        , _react2.default.createElement('span', { className: "blm-input-section--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}, "Password")
        , _react2.default.createElement(_PasswordInput2.default, {
          inputId: passwordInputId,
          value: password,
          autoComplete: "new-password",
          onChange: handleChange,
          onBlur: onPasswordBlur,
          onValidated: setPasswordStrength,
          maxLength: _app.MAX_PASSWORD_LENGTH, __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
        )
      )
      , _react2.default.createElement('label', { className: "blm-input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
        , _react2.default.createElement('span', { className: "blm-input-section--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}, "Confirm password" )
        , _react2.default.createElement(_PasswordInput2.default, {
          inputId: passwordConfirmationInputId,
          autoComplete: "new-password",
          value: passwordConfirmation,
          onChange: handleChange,
          onBlur: onConfirmationBlur,
          maxLength: _app.MAX_PASSWORD_LENGTH, __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}
        )
      )
      , _react2.default.createElement(_AuthFrame.FieldError, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
        ,  (isAnyFieldTouched && shownValidationError) || errorMessage 
      )
      , _react2.default.createElement(_Form.Button, {
        isSubmit: true,
        isDisabled: !isSubmitBtnEnabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
, "Save"

      )
    )
  )
}

exports. default = _react.memo.call(void 0, ResetPasswordForm)
